import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getMailingsPaged: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/mailings/paged`
    },
    getMailings: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/mailings/`,
        params: {
            '$count': true
        }
    },
    hasAccessToEZMail: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/mailings/hasAccessToEZMail`
    },
    getMailing: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/mailings/:id`
    },
    deleteMailing: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/communication/mailings/:id`
    },
    orderEZMail: {
        method: 'PUT',
        url: `${BASE_PATH_API}/communication/mailings/:id/ezMail`
    },
    pricingPlan: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/mailings/ezMailPricingPlan`
    },
    markAsMailed: {
        method: 'PUT',
        url: `${BASE_PATH_API}/communication/mailings/:id/markAsMailed`
    },
    cancelEZMailOrder: {
        method: 'PUT',
        url: `${BASE_PATH_API}/communication/mailings/:id/cancelEzMailOrder`
    },
    getMailingRecipients: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/mailings/:id/mailingRecipients`,
        isArray: true
    },
    getRecipients: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/mailings/:recipientType/recipients`,
        isArray: true
    },
    deletePendingMailings: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/communication/mailings/pending`
    },
    createMailing: {
        method: 'POST',
        url: `${BASE_PATH_API}/communication/mailings`
    },
    previewMailing: {
        method: 'POST',
        url: `${BASE_PATH_API}/communication/mailings/preview`
    },
    exportMailingLabels: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/mailings/:id/mailingLabels`
    }
};

export function MailingsApi() {
    return createActions(actions);
}
